var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountChange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 16.6667H17.5",
    stroke: "#E6E8ED",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 2.91694C14.0815 2.58542 14.5312 2.39917 15 2.39917C15.2321 2.39917 15.462 2.44489 15.6765 2.53373C15.891 2.62257 16.0858 2.75278 16.25 2.91694C16.4142 3.08109 16.5444 3.27597 16.6332 3.49044C16.722 3.70492 16.7678 3.93479 16.7678 4.16694C16.7678 4.39908 16.722 4.62896 16.6332 4.84343C16.5444 5.05791 16.4142 5.25278 16.25 5.41694L5.83333 15.8336L2.5 16.6669L3.33333 13.3336L13.75 2.91694Z",
    stroke: "#E6E8ED",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountChange);
export default __webpack_public_path__ + "static/media/account-change.210b07bf5556440fa0f7d3a480f3e201.svg";
export { ForwardRef as ReactComponent };